import { HTTPVerb } from '@sift/resift/redux/DataService';
import dataServiceActionHandlers from '@sift/resift/redux/reducers/dataServiceActionHandlers'; // A dependency for 'reducers.js'
import { isDebugEnabled, routeToDebugPage } from 'components/Router/Helper';
import config from 'config';
import _get from 'lodash';

// Store
import { CONFIG_FETCH, FIELD_UPDATE } from 'store/configuration';
import { CATEGORY_FIELD_CREATE } from 'store/attribute';

import { AUTHENTICATION_PERSON_FETCH } from 'store/authentication';
import { SEARCH_PEOPLE_FETCH } from 'store/search';
import { PERSON_FETCH, SEND_INVITE, SEND_INVITE_ALL, SEND_RESETPASSWORD } from 'store/people';

import {
  SOURCE_CREATE,
  SOURCE_INIT,
  SOURCE_FETCH,
  SOURCE_SAVE,
  SOURCE_DELETE,
  SOURCE_PUBLIC_KEY_SAVE,
  SIGNED_UPLOAD_FETCH,
  SOURCE_FILE_CREATE,
  SOURCE_FILE_HEADINGS_FETCH,
  SOURCE_SYNC_QUEUE,
  SOURCE_SYNC_ENABLE,
  SOURCE_PRIMARY_MAPPING_UPDATE,
  SOURCE_MAPPINGS_SAVE,
  SOURCE_FILE_MAPPINGS_FETCH,
  SOURCE_FIELDS_SAVE,
} from 'store/sources';
import { FEATURE_UPDATE, CLIENT_UPDATE } from 'store/client';
import {
  DIRECTORIES_FETCH,
  DIRECTORY_FETCH,
  DIRECTORY_CREATE,
  DIRECTORY_DELETE,
  DIRECTORY_SAVE,
} from 'store/directories';

import { THEMES_CREATE_FETCH, THEMES_GET_ALL_FETCH } from 'store/themes';

import { GROUPS_FETCH } from 'pages/Source/reducer';

import {
  INVITES_TEMPLATE_FETCH,
  INVITES_TEMPLATE_UPDATE,
  INVITES_TEMPLATE_EMAIL_TEST,
} from 'pages/Invites/reducer';

import { SIFT_BOT_FETCH, SIFT_BOT_UPDATE } from 'store/siftBot';

export const unauthorizedHandler = (next, action, authState) => {
  const handler = _get(action, ['dataServiceHandler'], {});

  if (handler.hasOwnProperty('authenticationRequired') && !handler.authenticationRequired) {
    return false;
  }

  // this prevents development environment from redirecting
  if (isDebugEnabled()) {
    routeToDebugPage();
    return false;
  }

  const subdomain = window.location.hostname.split('.')[0];

  if (getQueryVariable('samlRedirect') === 'true') {
    window.location.href = `${
      config.LOGIN
    }/api/login/${subdomain}/saml?redirectTo=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`;
  } else {
    window.location.href = `${config.LOGIN}/login?redirectTo=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`;
  }

  return true;
};

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export const DataServiceActionHandlers = {
  ...dataServiceActionHandlers,
  [FEATURE_UPDATE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return 'client/features';
    },
  },
  [AUTHENTICATION_PERSON_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'people/me',
  },
  [CONFIG_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return `configurations/${action.payload.configType}?returnDisabledFields=true`;
    },
  },
  [FIELD_UPDATE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      const { field } = action.payload;

      return `fields/${field.id}`;
    },
  },
  [CATEGORY_FIELD_CREATE]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `fields`;
    },
  },
  [SEARCH_PEOPLE_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return 'search/users';
    },
  },
  [PERSON_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return 'people/' + action.payload.personId;
    },
  },

  [SEND_INVITE]: {
    httpMethod: HTTPVerb.POST,
    route: 'people/invite',
  },
  [SEND_INVITE_ALL]: {
    httpMethod: HTTPVerb.POST,
    route: 'people/invite/all',
  },
  [SEND_RESETPASSWORD]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `people/${action.payload.id}/resetpassword`;
    },
  },
  [DIRECTORIES_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'directories',
  },
  [DIRECTORY_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return `directories/${action.payload.id}`;
    },
  },
  [DIRECTORY_CREATE]: {
    httpMethod: HTTPVerb.POST,
    route: 'directories',
  },
  [DIRECTORY_DELETE]: {
    httpMethod: HTTPVerb.DELETE,
    route: (authentication, action) => {
      return `directories/${action.payload.id}`;
    },
  },
  [DIRECTORY_SAVE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `directories/${action.payload.data.id}`;
    },
  },
  [SOURCE_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return `sources/${action.payload.sourceId}`;
    },
  },
  [SOURCE_SAVE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `sources/${action.payload.id}`;
    },
  },
  [SOURCE_FIELDS_SAVE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `sources/${action.payload.id}/fields`;
    },
  },
  [SOURCE_MAPPINGS_SAVE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `sources/${action.payload.id}/mappings`;
    },
  },
  [GROUPS_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (state, action) => {
      return `sources/${action.payload.id}/groups`;
    },
  },

  [CLIENT_UPDATE]: {
    httpMethod: HTTPVerb.PUT,
    route: 'client',
  },
  [SOURCE_CREATE]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `sources`;
    },
  },
  [SOURCE_INIT]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `sources/${action.payload.id}/initialize`;
    },
  },
  [SOURCE_DELETE]: {
    httpMethod: HTTPVerb.DELETE,
    route: (authentication, action) => {
      return `sources/${action.payload.id}`;
    },
  },
  [SOURCE_PUBLIC_KEY_SAVE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `sources/${action.payload.id}/fields/public-key`;
    },
  },
  [INVITES_TEMPLATE_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'communications/email/templates/invite',
  },
  [INVITES_TEMPLATE_UPDATE]: {
    httpMethod: HTTPVerb.PUT,
    route: 'communications/email/templates/invite',
  },
  [INVITES_TEMPLATE_EMAIL_TEST]: {
    httpMethod: HTTPVerb.POST,
    route: 'communications/email/templates/invite/test',
  },
  [SIGNED_UPLOAD_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'source-files/sign-upload',
  },
  [SOURCE_FILE_HEADINGS_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (auth, action) => `source-files/${action.payload.id}/headers`,
  },
  [SOURCE_FILE_CREATE]: {
    httpMethod: HTTPVerb.POST,
    route: 'source-files',
  },
  [SOURCE_FILE_MAPPINGS_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (authentication, action) => {
      return `source-files/${action.payload.sourceFileId}/mappings`;
    },
  },
  [SOURCE_SYNC_ENABLE]: {
    httpMethod: HTTPVerb.PUT,
    route: (authentication, action) => {
      return `sources/${action.payload.sourceId}/sync-enabled`;
    },
  },
  [SOURCE_SYNC_QUEUE]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `sources/${action.payload.sourceId}/initialize-sync`;
    },
  },
  [SOURCE_PRIMARY_MAPPING_UPDATE]: {
    httpMethod: HTTPVerb.POST,
    route: (authentication, action) => {
      return `sources/${action.payload.sourceId}/primary-mapping`;
    },
  },
  [SIFT_BOT_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'sift-bot',
  },
  [SIFT_BOT_UPDATE]: {
    httpMethod: HTTPVerb.PUT,
    route: 'sift-bot',
  },
  [THEMES_CREATE_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: 'themes',
  },
  [THEMES_GET_ALL_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: 'themes',
  },
};

export default DataServiceActionHandlers;
